import { z } from 'zod';
import { Z_PERCENTAGE } from '../../..';

export const editOfaInfoStep2FormSchema = z.object({
  avaitActiviteApprentissage: z.string().optional(),
  horsLesMurs: z.string().optional(),
  dateDebutActivite: z.string().optional(),
  dateDebutExerciceComptable: z.string().optional(),
  dateFinExerciceComptable: z.string().optional(),

  partActiviteApprentissage: z.preprocess(
      (val) => (val === '' ? undefined : val),
      Z_PERCENTAGE(),
  ).optional(),

  hasGroupe: z.string().optional(),
  groupe: z.string().optional(),
  hasReseau: z.string().optional(),
  reseau: z.string().optional(),

  cfa: z.string().optional(),
  sousTraitant: z.string().optional(),
})
  .superRefine((form, ctx) => {
    // On force la saisie du groupe si "Oui" a été sélectionné
    if (form.hasGroupe === 'true' && (!form.groupe || form.groupe.trim() === '')) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Ce champ est obligatoire',
        path: ['groupe'],
      });
    }
    // On force la saisie du réseau si "Oui" a été sélectionné
    if (form.hasReseau === 'true' && (!form.reseau || form.reseau.trim() === '')) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Ce champ est obligatoire',
        path: ['reseau'],
      });
    }

    if (form.dateDebutExerciceComptable && form.dateFinExerciceComptable && new Date(form.dateFinExerciceComptable) < new Date(form.dateDebutExerciceComptable)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'La date de fin doit être ultérieure à la date de début d\'exercice comptable',
        path: ['dateFinExerciceComptable'],
      });
    }
    if (form.dateFinExerciceComptable && form.dateDebutActivite && new Date(form.dateFinExerciceComptable) < new Date(form.dateDebutActivite)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'La date de fin doit être ultérieure à la date de début d\'activité',
        path: ['dateFinExerciceComptable'],
      });
    }
  });

export type EditOfaInfoStep2FormResult = z.infer<typeof editOfaInfoStep2FormSchema>